<div class="quartz-schedule">
  <div class="quartz-schedule__full">
    <span>{{ 'How often' | translate }}</span>
    <div class="quartz-schedule__kinds" role="radiogroup" [attr.aria-label]="'How often' | translate">
      @for (option of kindOptions; track option.id) {
        <button
          type="button"
          class="quartz-schedule__kind"
          [class.quartz-schedule__kind--active]="kind() === option.id"
          [attr.aria-pressed]="kind() === option.id"
          (click)="onKindChange(option.id)"
        >{{ option.label | translate }}</button>
      }
    </div>
  </div>

  @if (showOffset()) {
    <label>
      <span>{{ 'QUARTZ_START_OFFSET_MINUTES' | translate }}</span>
      <msf-input
        [model]="offsetInput()"
        type="number"
        step="1"
        (modelChange)="onOffsetChange($event)"
      ></msf-input>
      @if (offsetError()) {
        <small role="alert">{{ 'QUARTZ_START_OFFSET_ERROR' | translate }}</small>
      }
    </label>
  }

  @if (showEveryHours()) {
    <label>
      <span>{{ 'Repeat every' | translate }}</span>
      <div class="quartz-schedule__inline">
        <msf-select
          [model]="everyHours()"
          [options]="hourIntervalOptions"
          optionLabel="label"
          optionValue="id"
          translateBy="none"
          (modelChange)="onEveryHoursChange($event)"
        ></msf-select>
        <span>{{ 'Hours' | translate }}</span>
      </div>
    </label>
  }

  @if (showWeekday()) {
    <label>
      <span>{{ 'Day of week' | translate }}</span>
      <msf-select
        [model]="weekday()"
        [options]="weekdayOptions"
        optionLabel="label"
        optionValue="id"
        translateBy="locale"
        (modelChange)="onWeekdayChange($event)"
      ></msf-select>
    </label>
  }

  @if (showMonthDay()) {
    <label>
      <span>{{ 'Day of month' | translate }}</span>
      <msf-select
        [model]="monthDay()"
        [options]="monthDayOptions"
        optionLabel="label"
        optionValue="id"
        translateBy="none"
        (modelChange)="onMonthDayChange($event)"
      ></msf-select>
    </label>
  }

  @if (showTime()) {
    <label>
      <span>{{ 'Time' | translate }}</span>
      <app-date-picker
        [timeOnly]="true"
        [showTime]="true"
        [hourFormat]="'24'"
        [showIcon]="false"
        [placeholder]="'Time' | translate"
        [ngModel]="timeValue()"
        (ngModelChange)="onTimeChange($event)"
      ></app-date-picker>
    </label>
  }

  <label class="quartz-schedule__full">
    <span>{{ 'Time zone' | translate }}</span>
    <msf-select
      [model]="timeZoneId()"
      [options]="timeZoneOptions()"
      optionLabel="label"
      optionValue="id"
      translateBy="none"
      [placeholder]="'Select time zone' | translate"
      (modelChange)="timeZoneId.set($event)"
    ></msf-select>
  </label>

  @if (showCustomExpression()) {
    <label class="quartz-schedule__full">
      <span>{{ 'Advanced schedule' | translate }}</span>
      <msf-input
        [model]="customExpression()"
        [placeholder]="'0 0 6 * * ?'"
        (modelChange)="onCustomExpressionChange($event)"
      ></msf-input>
      <small>{{ 'Quartz cron hint' | translate }}</small>
    </label>
  } @else {
    <div class="quartz-schedule__summary quartz-schedule__full">
      <strong>{{ summary() }}</strong>
      @if (nextRunLabel()) {
        <span>{{ nextRunLabel() }}</span>
      }
      <small>{{ timeZoneSummary() }}</small>
    </div>
  }
</div>
